import { UAParser } from 'ua-parser-js';

export const getDeviceInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    device: result.device.model
      ? `${result.device.vendor} ${result.device.model}`
      : 'Desktop',
    browser: `${result.browser.name} ${result.browser.version}`,
    os: `${result.os.name} ${result.os.version}`,
    userAgent: result.ua,
  };
};

export const enrichWithDeviceInfo = (data) => {
  const adminId = localStorage.getItem('user_id');
  const deviceInfo = getDeviceInfo();

  return {
    ...data,
    adminId,
    ...deviceInfo,
  };
};
